import { TenantRoute } from "../components/ProtectedRoute";

export default [TenantRoute];